import { lazy, Suspense, React } from 'react';
import { Switch } from 'react-router-dom';
import { AppLayout } from '../../layouts';
import { EbPageLoader } from '../Common';


const GST = lazy(() => import('.').then((module) => ({ default: module.GST })));
const DirectTax = lazy(() => import('.').then((module) => ({ default: module.DirectTax })));


const GSTRouter = (props) => {
    const AppRoute = props.AppRoute;
    return (
        <Switch>
            <Suspense fallback={<EbPageLoader />}>
                <AppRoute exact path="/gst" layout={AppLayout} component={GST} pathkey="gst" />
                <AppRoute exact path="/direct_tax" layout={AppLayout} component={DirectTax} pathkey="direct_tax" />
            </Suspense>
        </Switch>
    )
}

export { GSTRouter };